import { translations } from './de';

const searchRegExp = /{([^}]+)}/g;

export const translate: TranslateFn = (template, replacements) => {
    // log missing translation
    if (!translations[template]) {
        //console.log(`"${template}": '',`);
    }

    // Translate
    template = translations[template] || template;

    // check replacements to omit template.replace call
    if (!replacements || Object.keys(replacements).length < 1) {
        return template;
    }

    // Replace
    return template.replace(searchRegExp, (_substring, key) => replacements[key] || `{${key}}`);
};
